module.exports = __webpack_public_path__ + "img/19 companieros.4869803a.jpg";